import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router-dom"
import { handleCleanForm, handleStartEditing } from "../../../redux/actions/form"
import { setSchema } from "../../../redux/actions/validator"
import BreadCrumbs from "../breadcrumbs"
import { BlockRenderContext } from "../../../utility/context/BlockRenderContext"
import { BlockInterpreter } from "./BlockInterpreter"


export const FormInterpreter = ({
    title,
    form,
    endPoint,
    handleSubmit = null,
    onSubmit,
    onCancel = null,
    parentKey = null,
    breadCrumbs = true,
    extraStructure = {},
    buttonStyles = {},
    extraOptions = []
}) => {

    const { pills, blocks, structure, errors } = form
    const dispatch = useDispatch()
    const location = useLocation()
    const { form: f } = useSelector(state => state)
    const { id, parentId = null } = useParams()

    const [activePill, setActivePill] = useState(null)
    const activeBlocks = blocks?.filter(b => b.pillId === activePill)
    const nonPillableBlocks = blocks?.filter(b => b.pillId === undefined)

    const breadCrumbTitle = id ? `Editar ${title}` : `Añadir ${title}`

    useEffect(() => {
        dispatch(handleCleanForm())
        dispatch(setSchema(errors))
    }, [location.pathname])

    useEffect(() => {
        setActivePill(pills?.find(p => p.active).id || null)
        dispatch(handleStartEditing(endPoint, id, parentKey ? { ...structure, ...extraStructure, [parentKey]: parseInt(parentId) } : { ...structure, ...extraStructure }))
    }, [pills || structure || extraStructure])

    return (
        <div>
            {

                (Object.keys(f).length || Object.keys(structure).length === 0) && (
                    <>
                        {breadCrumbs && <BreadCrumbs
                            breadCrumbTitle={breadCrumbTitle}
                            breadCrumbParent={title}
                            endPoint={endPoint}
                            handleSubmit={handleSubmit}
                            onSubmit={onSubmit}
                            onCancel={onCancel}
                            buttonStyles={buttonStyles}
                            extraOptions={extraOptions}
                        />}
                        <>
                            <BlockRenderContext.Provider value={{ activePill, setActivePill }}>
                                {pills && <PillsInterpreter pills={pills} />}
                                <div className='row m-0'>
                                    {activeBlocks?.map((block, i) => <BlockInterpreter key={`pilledBlock_${i}`} block={block} />)}
                                </div>
                            </BlockRenderContext.Provider>
                            <div className='row m-0'>
                                {nonPillableBlocks?.map((block, i) => <BlockInterpreter key={`nonPilledBlock_${i}`} block={block} />)}
                            </div>
                        </>
                    </>
                )
            }
        </div>
    )
}
